export const productCardFliDesktopConverter = (props)=>{
    const data = props.props ?? props.data ?? {};
    const { config ={} , title ='' , subtitle , link ={
        href: ''
    } , imgSrc ='' , imgAlt , imgAlternative , deal =false , price , priceLabel , departureContent , returnContent , tag , tooltip  } = data;
    const image = {
        src: imgSrc,
        alt: imgAlt,
        alternative: imgAlternative
    };
    return {
        ...data,
        config: {
            ...config,
            soldOut: props.soldOut,
            deal,
            icon: true,
            iconName: 'plane',
            literals: {
                fromCaption: priceLabel,
                ...config.literals
            },
            typeCard: 'new',
            hasModal: true
        },
        image,
        link,
        price: {
            value: price,
            from: !!priceLabel
        },
        tag,
        tooltip,
        title,
        subtitle,
        returnContent,
        departureContent,
        descriptions: [
            ''
        ]
    };
};

//# sourceMappingURL=converter.js.map